// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zIJVPGQF4njDH3 {
  position: relative;
  z-index: 0;
  height: 100%;
}
.rS_fRLERojcxuz,
.Ugs00R5UiGe81t,
.S_A3Rn6gbBmD3l {
  position: absolute;
  top: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
}
@media print {
  .rS_fRLERojcxuz,
  .Ugs00R5UiGe81t,
  .S_A3Rn6gbBmD3l {
    position: relative;
  }
}
.S_A3Rn6gbBmD3l {
  z-index: 20;
}
.Ugs00R5UiGe81t {
  z-index: 19;
}
.rS_fRLERojcxuz {
  z-index: 80;
}
.OvvZPv959uL2HC {
  position: fixed;
  z-index: 2;
  top: var(--ds-space-500, 40px);
  right: var(--ds-space-050, 4px);
  max-width: 270px;
}
.dgcxFxOT9GNlkj {
  position: fixed;
  z-index: 100;
  bottom: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
}
.HqZ4asQ2Nb10Li {
  position: absolute;
  z-index: 70;
  top: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
}
.yGWguyUrzUcgEN {
  position: absolute;
  z-index: 4;
  top: var(--ds-space-0, 0);
  right: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
}
`, ""]);
// Exports
export var appLayer = `zIJVPGQF4njDH3`;
export var overlayLayer = `rS_fRLERojcxuz`;
export var discoveryAdLayer = `Ugs00R5UiGe81t`;
export var cardBackLayer = `S_A3Rn6gbBmD3l`;
export var alertLayer = `OvvZPv959uL2HC`;
export var flagLayer = `dgcxFxOT9GNlkj`;
export var popoverLayer = `HqZ4asQ2Nb10Li`;
export var tooltipLayerRef = `yGWguyUrzUcgEN`;
export default ___CSS_LOADER_EXPORT___;
